<template>
  <div>
    <div class="opt position-relative mt-0 cursor-pointer" @click="openAttendeeOptions" v-click-outside="onClickOutside" v-if="currentIsAdmin != 0 || (isOwnProfile && user.event_attendee_status == 1)">
      <img src="../../assets/Svg/ellipse.svg" alt="" />
      <div class="sub-setting-options" v-if="attendeesOptions">
        <ul class="d-block pb-0">
          <li v-if="currentIsAdmin != 0 && user.event_attendee_status != 0" @click="editAttendance(user)" class="cursor-pointer">
            <img src="../../assets/Svg/team/team-options/edit-2.svg" alt="edit" />
            <p>Edit Attendance</p>
          </li>
          <li v-if="currentIsAdmin != 0 && user.event_attendee_status == 0" @click="markAttendance(user)" class="text-danger cursor-pointer">
            <img src="../../assets/Svg/document-text.svg" alt="attendence" />
            <p>Mark Attendance</p>
          </li>
          <li v-if="user.event_attendee_status == 1" @click="editTravel(user)" class="cursor-pointer">
            <img src="../../assets/Svg/team/team-options/edit-2.svg" alt="">
            <p>Edit Travel Details</p>
          </li>
        </ul>
      </div>
    </div>
    <EditEventAttendessModal :selectedRoomTeam="selectedRoomTeam" :singleEvent="singleEvent" />
</div>

</template>

<script>
import axios from "axios";
import EditEventAttendessModal from "../Teams/ChatRight/ChatEvents/EditEventAttendessModal.vue";

export default {
  name: "AttendeesOptions",
  components: {
    EditEventAttendessModal
  },
  data() {
    return {
      attendeesOptions: false,
    };
  },
  props: {
    selectedRoomTeam: {
      type: Object,
    },
    singleEvent: {
      type: Object,
    },
    currentIsAdmin: {
      type: String,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
  isOwnProfile() {
    const loggedInUserId = localStorage.getItem("userId");
    return this.user?.c_id === loggedInUserId;
  }
},
  methods: {
    openAttendeeOptions() {
      this.attendeesOptions = !this.attendeesOptions;
    },
    onClickOutside() {
      this.attendeesOptions = false;
    },
    editAttendance: function (user) {
      this.$root.$emit("openEditAttendeesModal", user);
      var elem = this.$refs.openModalEventClose;
      if (elem) {
        elem.click();
      }
    },

async editTravel(user) {
    try {
      // Prepare form data
      const formData = new FormData();
      formData.append("event_id", this.singleEvent.id);
      formData.append("member_id", user.c_id);

      // Call API to fetch attendee services/details
      const response = await axios.post(
        process.env.VUE_APP_API_URL + "event/getEventMemberDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const memberDetails = response.data.data.memberDetails;

      // Emit the modal with actual services data
      this.$root.$emit("openEditServicesModal", {
        event: this.singleEvent,
        services: memberDetails, // this was previously {}
        member_id: user.c_id,
      });

    } catch (error) {
      console.error("Failed to fetch attendee services:", error);
    }

    // Optionally close any open modals
    const elem = this.$refs.openModalEventClose;
    if (elem) {
      elem.click();
    }
  },

    markAttendance: function (user) {
      this.$root.$emit("openEditMarkAttendeesModal", user);
      var elem = this.$refs.openModalEventClose;
      if (elem) {
        elem.click();
      }
    },
  },
};
</script>